import { render, staticRenderFns } from "./LegCustomData.vue?vue&type=template&id=4597d4a6&"
import script from "./LegCustomData.vue?vue&type=script&lang=js&"
export * from "./LegCustomData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports